/* Zubaz WOW pack (draft/lab):
   1) Team chrome — announcement bar takes the picked team's colors
   2) Gameday countdown — live strip counting down to the picked team's next game
   3) Hot-seller ticker — rotating best-seller toasts (product data only)
   Loaded from theme.liquid with data-gameday / data-ticker asset URLs. */
(function () {
  'use strict';
  var TAG = document.getElementById('zbz-wow-script');
  var GAMEDAY_URL = TAG ? TAG.getAttribute('data-gameday') : null;
  var TICKER_URL = TAG ? TAG.getAttribute('data-ticker') : null;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function textOn(hex) {
    if (window.zubazTeamTextColor) return window.zubazTeamTextColor(hex);
    var c = String(hex || '').replace('#', ''); if (c.length !== 6) return '#ffffff';
    return (0.299 * parseInt(c.substr(0, 2), 16) + 0.587 * parseInt(c.substr(2, 2), 16) + 0.114 * parseInt(c.substr(4, 2), 16)) > 150 ? '#000000' : '#ffffff';
  }
  function nick(name) { var p = String(name).split(' '); return p[p.length - 1].toUpperCase(); }
  function pickedTeam() {
    var h = window.zubazGetTeam && window.zubazGetTeam();
    if (h && window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[h]) return h;
    var m = location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
    if (m && window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[m[1]]) return m[1];
    return null;
  }

  /* ---------- 1) team chrome (announcement bar + sitewide button accents) ---------- */
  function applyChrome(handle) {
    var T = window.ZUBAZ_TEAMS[handle]; if (!T) return;
    var tc = textOn(T.primary);
    var st = document.getElementById('zbz-wow-chrome');
    if (!st) { st = document.createElement('style'); st.id = 'zbz-wow-chrome'; document.head.appendChild(st); }
    st.textContent =
      '[id*="__announcement-bar"], [id*="__announcement-bar"] .announcement-bar{background:' + T.primary + ' !important;border-bottom:3px solid ' + T.secondary + ';}' +
      '[id*="__announcement-bar"] *{color:' + tc + ' !important;}' +
      // Team-accented primary buttons everywhere (matches the treatment team
      // collection pages already get). Fit-builder add-all keeps its own style.
      '#main .button--primary:not(.zubaz-fb__addall), main .button--primary:not(.zubaz-fb__addall), .zbz-bf-qb.button--primary, .zbz-srch-qb.button--primary{background:' + T.primary + ' !important;color:' + tc + ' !important;}';
  }

  /* ---------- 1b) cart rail speaks fan ("More Bills Mafia essentials") ---------- */
  function fanCartHeadings(handle) {
    var T = handle && window.ZUBAZ_TEAMS[handle]; if (!T || !T.slogan) return;
    document.querySelectorAll('.mini-cart__recommendations-heading').forEach(function (h) {
      if (h.textContent.indexOf(T.name) >= 0) h.textContent = 'More ' + T.slogan + ' essentials';
    });
  }
  function watchCart() {
    var t = null;
    function run() { clearTimeout(t); t = setTimeout(function () { fanCartHeadings(pickedTeam()); }, 250); }
    document.addEventListener('cart:refresh', run);
    var host = document.getElementById('shopify-section-mini-cart');
    if (host) new MutationObserver(run).observe(host, { childList: true, subtree: true });
    run();
  }

  /* ---------- 2) gameday countdown ---------- */
  var cdTimer = null;
  function applyCountdown(handle) {
    if (!GAMEDAY_URL) return;
    var T = window.ZUBAZ_TEAMS[handle]; if (!T) return;
    fetch(GAMEDAY_URL).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (feed) {
      var g = feed.teams && feed.teams[handle]; if (!g) return;
      var kick = new Date(g.kick).getTime();
      if (isNaN(kick) || Date.now() > kick + 4 * 3600e3) return; // stale entry
      var el = document.getElementById('zbz-gameday');
      if (!el) {
        el = document.createElement('a');
        el.id = 'zbz-gameday'; el.className = 'zbz-gameday';
        var host = document.querySelector('[id*="__announcement-bar"]');
        if (host && host.parentNode) host.parentNode.insertBefore(el, host.nextSibling);
        else document.body.insertBefore(el, document.body.firstChild);
      }
      el.href = '/collections/' + handle;
      // Matchup mode (fan kit): clicking the strip opens the team-vs-opponent
      // overlay when available; the collection link stays as the fallback.
      if (!el.dataset.muWired) {
        el.dataset.muWired = '1';
        el.addEventListener('click', function (e) {
          try { if (typeof window.gtag === 'function') window.gtag('event', 'zbz_next_game_click', { team: (el.getAttribute('href') || '').replace('/collections/', '') }); } catch (err) { }
          if (window.zbzMatchup && window.zbzMatchup()) e.preventDefault();
        });
      }
      el.style.background = T.secondary; el.style.color = textOn(T.secondary);
      function tick() {
        var d = kick - Date.now(), label, sub = '';
        if (d <= 0) label = '🏈 GAME ON — REP THE STRIPES →';
        else if (d < 24 * 3600e3) {
          var kt = new Date(kick);
          label = '🏈 ' + nick(T.name) + ' KICK OFF TODAY ' + kt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) + ' — GEAR UP →';
        } else {
          var days = Math.floor(d / 86400e3), hrs = Math.floor((d % 86400e3) / 3600e3);
          // Feed can carry an empty opp (unparseable matchup) — fall back to "NEXT GAME".
          label = '🏈 ' + nick(T.name) + (g.opp ? ' ' + (g.home ? 'VS' : '@') + ' ' + esc(g.opp) : ' NEXT GAME') + ' IN ' + days + 'D ' + hrs + 'H — GEAR UP →';
          // Shipping-cutoff nudge: free US shipping runs ~5 business days, so
          // ~7 calendar days before kickoff is the safe order-by date. Only
          // shown inside the 3-week window where it drives urgency.
          if (days <= 21 && days >= 7) {
            var cutoff = new Date(kick - 7 * 86400e3);
            var DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
            sub = 'ORDER BY ' + DAYS[cutoff.getDay()] + ' ' + (cutoff.getMonth() + 1) + '/' + cutoff.getDate() + ' TO HAVE IT FOR GAMEDAY';
          }
        }
        // Preseason games count too — tag them so fans know which game this is.
        if (g.pre) sub = sub ? 'PRESEASON • ' + sub : 'PRESEASON';
        el.innerHTML = esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '');
      }
      tick();
      if (cdTimer) clearInterval(cdTimer);
      cdTimer = setInterval(tick, 30000);
    }).catch(function () { });
  }

  /* ---------- 3) hot-seller ticker — REMOVED (Eli, 2026-07-09) ----------
     Was max once/session since 07-08; fully retired 07-09. The data-ticker
     asset + theme.liquid attribute remain harmlessly unused. ---------------- */

  function applyTeam() {
    var h = pickedTeam();
    if (h) applyChrome(h);
    // Countdown strip ONLY for an explicitly picked team (Eli 2026-07-07):
    // browsing a team's collection page must not surface that team's next
    // game — pickedTeam()'s URL fallback is for chrome/cart copy only.
    var picked = window.zubazGetTeam && window.zubazGetTeam();
    if (picked && window.ZUBAZ_TEAMS[picked]) applyCountdown(picked);
  }
  /* ---------- 4) '90s mode extras: cursor sparkle trail ---------- */
  function init90s() {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var last = 0;
    var GLYPHS = ['✦', '✧', '★', '·'];
    document.addEventListener('pointermove', function (e) {
      if (!document.documentElement.classList.contains('zubaz-90s')) return;
      var now = Date.now();
      if (now - last < 90) return; // throttle
      last = now;
      var s = document.createElement('span');
      s.className = 'zbz-sparkle';
      s.textContent = GLYPHS[(Math.random() * GLYPHS.length) | 0];
      s.style.left = (e.clientX + 6) + 'px';
      s.style.top = (e.clientY + 8) + 'px';
      s.style.color = Math.random() > 0.5 ? '#f3ff34' : '#ff37b8';
      document.body.appendChild(s);
      setTimeout(function () { s.remove(); }, 900);
    }, { passive: true });
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 250); return; }
    applyTeam();
    document.addEventListener('zubaz:team', applyTeam);
    watchCart();
    init90s();
  }
  ready(boot);
})();
